




























































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component, Watch } from 'vue-property-decorator'
import { APIPermission } from '../../models/api/permission.model'

@Component
export default class RolesPermissionsForm extends Vue {
    loading = true
    data: {[key: string]: unknown} = {}

    cardTitle = ''

    buttonLoading = false

    formData: {
        permissions?: APIPermission[];
    } = {}

    formValid = false
    formRules = {
        name: [
            (v: string) => !!v || 'Name is required',
            (v: string) => (v && v.length <= 191) || 'Name must be less than 191 characters'
        ],
        typeId: [
            (v: string) => !!v || 'Type is required'
        ]

    }

    formModel: { permissions: APIPermission[] } = {
        permissions: []
    }

    @Watch('formData')
    formUpdateHandler () {
        this.$forceUpdate()
    }

    async mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not action sended in route params :(' })
            return
        }

        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Role Permissions'
            await this.getData()
            await this.getPermissions()

            break
        }
    }

    getData () {
        this.loading = true
        return new Promise(resolve => {
            if (!this.$route.params.id) {
                this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
                this.loading = false
                return
            }

            this.$store.dispatch('getRolesById', this.$route.params.id)
                .then(resp => {
                    if (resp?.status === 200) {
                        this.formData = this.$store.state.RolesStore.roleForm
                        this.loading = false
                        return resolve()
                    }
                })
        })
    }

    getPermissions () {
        this.loading = true
        this.$store.dispatch('getPermissions', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formModel.permissions = JSON.parse(JSON.stringify(this.$store.state.PermissionsStore.permissions))

                    this.formModel.permissions.forEach(a => {
                        if (this.formData.permissions && this.formData.permissions.find(b => b.permissionId === a.permissionId)) {
                            a.active = true
                        }
                    })
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        const addedPermissions: APIPermission[] = []
        const removedPermissions: APIPermission[] = []

        this.formModel.permissions.forEach(permission => {
            if (permission.active && this.formData.permissions && !this.formData.permissions.find(formPermission => formPermission.permissionId === permission.permissionId)) {
                addedPermissions.push(permission)
            }
            if (!permission.active && this.formData.permissions && this.formData.permissions.find(formPermission => formPermission.permissionId === permission.permissionId)) {
                removedPermissions.push(permission)
            }
        })

        this.buttonLoading = true

        if (addedPermissions.length > 0) {
            this.$store.dispatch(
                'addPermissionToRole',
                {
                    roleId: this.$route.params.id,
                    permissions: addedPermissions
                })
                .then(async (resp) => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        await this.getData()
                        await this.getPermissions()
                        this.buttonLoading = false
                    }
                })
        }
        if (removedPermissions.length > 0) {
            this.$store.dispatch(
                'removePermissionToRole',
                {
                    roleId: this.$route.params.id,
                    permissions: removedPermissions
                })
                .then(async (resp) => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        await this.getData()
                        await this.getPermissions()
                        this.buttonLoading = false
                    }
                })
        }
    }
}
